import React from 'react';

const VedaStamp = ({ veda = 'yajur', className = '' }) => {
  const configs = {
    yajur: {
      title_ta: 'ஆபஸ்தம்ப யஜுர் வேதம்',
      title_en: 'Apastamba Yajur Vedam',
      sub_ta: 'க்ருஷ்ண யஜுர் வேத ஆபஸ்தம்ப சூத்ர பிரயோகம்',
      icon: '📜',
      bgColor: 'bg-amber-100/90',
      borderColor: 'border-[#CC6600]',
      textColor: 'text-[#1A237E]',
      badgeColor: 'bg-[#CC6600] text-white'
    },
    sama: {
      title_ta: 'சாந்தோக்ய ஸாம வேதம்',
      title_en: 'Chandogya Sama Vedam',
      sub_ta: 'ஸாம வேத ஸ்மார்த்த சாந்தோக்ய சூத்ர பிரயோகம்',
      icon: '🎵',
      bgColor: 'bg-amber-50',
      borderColor: 'border-[#D4AF37]',
      textColor: 'text-[#1A237E]',
      badgeColor: 'bg-[#1A237E] text-amber-200'
    },
    rig: {
      title_ta: 'ஆச்வலாயன ருக் வேதம்',
      title_en: 'Ashvalayana Rig Vedam',
      sub_ta: 'ருக் வேத ஆச்வலாயன சூத்ர பிரயோகம்',
      icon: '📖',
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-500',
      textColor: 'text-orange-950',
      badgeColor: 'bg-orange-700 text-white'
    },
    general: {
      title_ta: 'பொது வைதீக சாஸ்திரம்',
      title_en: 'General Vaideekam Shastram',
      sub_ta: 'பூர்வாபர வைதீக சாஸ்திர விபரம்',
      icon: '🕉️',
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-400',
      textColor: 'text-[#1A237E]',
      badgeColor: 'bg-amber-800 text-white'
    }
  };

  const config = configs[veda] || configs.yajur;

  return (
    <div className={`inline-flex items-center space-x-3 px-4 py-2 rounded-2xl border-2 shadow-xs font-sans ${config.bgColor} ${config.borderColor} ${className}`}>
      <span className="text-xl md:text-2xl">{config.icon}</span>
      <div>
        <div className="flex items-center space-x-2">
          <span className={`text-[10px] font-extrabold uppercase px-2 py-0.5 rounded-full ${config.badgeColor}`}>
            வேத முத்திரை
          </span>
          <span className={`text-sm md:text-base font-bold ${config.textColor}`}>
            {config.title_ta}
          </span>
        </div>
        <div className="text-[11px] text-gray-700 font-medium">
          {config.sub_ta} ({config.title_en})
        </div>
      </div>
    </div>
  );
};

export default VedaStamp;
